// Generic confirmation modal — replaces ConfirmModalComponent.
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface ConfirmModalProps {
  title?: string;
  body?: string;
  cancelText?: string;
  confirmText?: string;
  onClose: (confirmed: boolean | null) => void;
}

export function ConfirmModal({
  title,
  body,
  cancelText,
  confirmText,
  onClose,
}: ConfirmModalProps) {
  const { t } = useTranslation();
  return (
    <Dialog open onClose={() => onClose(null)} maxWidth="xs" fullWidth>
      {title && <DialogTitle>{title}</DialogTitle>}
      {body && (
        <DialogContent>
          <Typography>{body}</Typography>
        </DialogContent>
      )}
      <DialogActions>
        <Button onClick={() => onClose(false)}>
          {cancelText ?? t('global.actions.cancel', { defaultValue: 'Cancel' })}
        </Button>
        <Button variant="contained" onClick={() => onClose(true)}>
          {confirmText ?? t('global.actions.confirm', { defaultValue: 'Confirm' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
